// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Commands.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { Command, ListenForCommandsRequest, SendCommandRequest, SendCommandResponse } from "./Models/CommandModels";

export const protobufPackage = "daisi.protos.v1";

export type HostCommandsProtoDefinition = typeof HostCommandsProtoDefinition;
export const HostCommandsProtoDefinition = {
  name: "HostCommandsProto",
  fullName: "daisi.protos.v1.HostCommandsProto",
  methods: {
    open: {
      name: "Open",
      requestType: Command,
      requestStream: true,
      responseType: Command,
      responseStream: true,
      options: {},
    },
    /** Browser-compatible split RPCs (grpc-web can't do bidi streaming) */
    listenForCommands: {
      name: "ListenForCommands",
      requestType: ListenForCommandsRequest,
      requestStream: false,
      responseType: Command,
      responseStream: true,
      options: {},
    },
    sendCommand: {
      name: "SendCommand",
      requestType: SendCommandRequest,
      requestStream: false,
      responseType: SendCommandResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface HostCommandsProtoServiceImplementation<CallContextExt = {}> {
  open(
    request: AsyncIterable<Command>,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<Command>>;
  /** Browser-compatible split RPCs (grpc-web can't do bidi streaming) */
  listenForCommands(
    request: ListenForCommandsRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<Command>>;
  sendCommand(
    request: SendCommandRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<SendCommandResponse>>;
}

export interface HostCommandsProtoClient<CallOptionsExt = {}> {
  open(request: AsyncIterable<DeepPartial<Command>>, options?: CallOptions & CallOptionsExt): AsyncIterable<Command>;
  /** Browser-compatible split RPCs (grpc-web can't do bidi streaming) */
  listenForCommands(
    request: DeepPartial<ListenForCommandsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<Command>;
  sendCommand(
    request: DeepPartial<SendCommandRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<SendCommandResponse>;
}

export type AppCommandsProtoDefinition = typeof AppCommandsProtoDefinition;
export const AppCommandsProtoDefinition = {
  name: "AppCommandsProto",
  fullName: "daisi.protos.v1.AppCommandsProto",
  methods: {
    open: {
      name: "Open",
      requestType: Command,
      requestStream: true,
      responseType: Command,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface AppCommandsProtoServiceImplementation<CallContextExt = {}> {
  open(
    request: AsyncIterable<Command>,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<Command>>;
}

export interface AppCommandsProtoClient<CallOptionsExt = {}> {
  open(request: AsyncIterable<DeepPartial<Command>>, options?: CallOptions & CallOptionsExt): AsyncIterable<Command>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };
